module.exports = __webpack_public_path__ + "img/piso.ef7fe651.png";